var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-page"},[_c('p',[_vm._v("正在处理授权登录...")])])
}]

export { render, staticRenderFns }